import React from 'react';
import {DataLoader} from 'src/js/common';
import {useAppSelector} from 'src/js/store_hooks';

import {useLoadTranslations} from '../hooks';
import {I18N_REDUCER_STATE_ID} from '../i18n_constants';
import {I18nState} from '../i18n_slice';

interface OwnProps extends DataLoader {}
type Props = OwnProps;

export function useCurrentLocale(): I18nState['currentLocale'] {
  return useAppSelector((state) => state[I18N_REDUCER_STATE_ID].currentLocale);
}
export const TranslationsLoader: React.FC<Props> = (props) => {
  const {apiUrl, id, children} = props;
  const currentLocale = useCurrentLocale();
  const {isLoading} = useLoadTranslations(apiUrl, currentLocale, id ?? apiUrl);
  return isLoading ? null : <>{children}</>;
};

TranslationsLoader.displayName = 'TranslationsLoader';
